import { useState, useEffect } from 'react';

// Main ArticleList component
export default function ArticleList() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch articles from Directus API
    const fetchArticles = async () => {
      try {
        setLoading(true);
        
        // Replace with your actual Directus API endpoint
	  const response = await fetch('https://cms.lizakhan.com/items/articles');
        
        if (!response.ok) {
          throw new Error(`Failed to fetch: ${response.status}`);
        }
        
        const data = await response.json();
        setArticles(data.data || []);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching articles:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchArticles();
  }, []);

  if (loading) {
    return <LoadingState />;
  }

  if (error) {
    return <ErrorState message={error} />;
  }

  if (articles.length === 0) {
    return <EmptyState />;
  }

  return (
	  <div className="container px-4 py-5">
	  <h2 className="pb-2 border-bottom">Articles</h2>
	  <div class="container my-5">
	  <div className="row">
          {articles.map(article => (
		  <div className="col-md-12 mb-4" key={article.id}>
		  <ArticleCard article={article} />
		  </div>
          ))}
      </div>
	  </div>
	  </div>
  );
}

// Article Card Component
function ArticleCard({ article }) {
  const { id, title, lead, leadImage, body } = article;
  
  // Get the asset URL for the lead image (adjust based on your Directus setup)
  const imageUrl = leadImage ? `https://cms.lizakhan.com/assets/${leadImage}` : null;
  
  return (
    <div className="card">
      <div className="row g-0">
        {imageUrl && (
          <div className="col-md-4">
            <img
              src={imageUrl}
              alt={title}
              className="img-fluid rounded-start"
              style={{ height: '100%', objectFit: 'cover' }}
            />
          </div>
        )}
        <div className={imageUrl ? "col-md-8" : "col-12"}>
          <div className="card-body">
            <h5 className="card-title">
              <a href={`/article/${id}`} className="articleLink text-decoration-none">{title}</a>
            </h5>
            <p className="card-text">{lead}</p>
            <a href={`/article/${id}`} className="btn btn-primary btn-sm">Read more</a>
          </div>
        </div>
      </div>
    </div>
  );
}

// Loading State Component
function LoadingState() {
  return (
    <div className="container py-4">
      <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3 text-secondary">Loading articles...</p>
        </div>
      </div>
    </div>
  );
}

// Error State Component
function ErrorState({ message }) {
  return (
    <div className="container py-4">
      <div className="alert alert-danger text-center" role="alert">
        <h4 className="alert-heading">Unable to load articles</h4>
        <p>{message}</p>
      </div>
    </div>
  );
}

// Empty State Component
function EmptyState() {
  return (
    <div className="container py-4">
      <div className="alert alert-secondary text-center" role="alert">
        <h4 className="alert-heading">No articles found</h4>
        <p>There are currently no articles available.</p>
      </div>
    </div>
  );
}


